import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'
import { container as TravelsContainer } from '../../modules/Travels'
import media from '../../media'
import './styles.css'

const TravelsView = () => {
    return (
        <MainLayout>
            <div className="row">
                <div className="col-md-12">
                    <PageTitle>Пътешествията</PageTitle>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-sm-10">
                    <p className="text-justify">Любословни потребителю на нашия сайт, предстои ти забавно узнаване! Последвай (не)вероятните пътешествия на „МЕДИЙНАТА МРЕЖА ПАИСИАДА“, пресъздадени за пръв път цялостно върху тази интерактивна карта!
                    </p>
                    <br/><br/>
                </div>
            </div>
            <TravelsContainer/>
            {/* <div className="row">
                <div className="col-sm-12">
                    <div className="map-container">
                        <iframe src="http://nauho.paissiada.com/map/"></iframe>
                    </div>
                </div>
            </div> */}
            <div className="row justify-content-center">
                <div className="col-sm-10">
                    <br/><br/>
                    <p className="text-justify">Е-картата пресъздава движенията на ръкописните книги от „Паисиада“. Местата, където са пътешествали книгите, съставени между 1762 и 1882 г., са отразени след обработка на наличната към момента документална информация, събирана в продължение на години. За някои от маршрутите, изминавани от ръкописната „Паисиада“, нямаме преки данни. В такива ситуации се сочи, че става дума за предполагаемо местопребиваване (временно местоположение). Работните термини, с които се назовават ръкописите, са обмислени с оглед на картографирането на маршрутите. Затова, когато е възможно при назоваването на ръкописа присъства и мястото, където е съставен оригиналът (или е открит по-късно).</p>
                    <br/>
                    <p className="text-justify">
                    Нашият проект за пръв път предлага ЕЛЕКТРОННА КАРТА-КАТАЛОГ не само на съхранените книги от ръкописния фонд на възрожденската „Паисиада“, но и на изгубените, а и на онези, които дълго са мислени за изгубени, защото временно са били „похитени“ от български и/или чужди ценители колекционери.
                    </p>
                </div>
            </div>
        </MainLayout>
    )
}


export default TravelsView



// WEBPACK FOOTER //
// ./src/views/Travels/index.jsx